(function () {
  function bind(g) {
    if (g.dataset.jiReorderBound) return;
    g.dataset.jiReorderBound = '1';

    var ids = (g.getAttribute('data-ji-variant-media') || '').split(',').filter(Boolean);
    if (!ids.length) return;

    var carousel = g.querySelector('media-carousel');
    var form = g.getAttribute('form') ? document.forms[g.getAttribute('form')] : null;

    function getSlides() {
      return Array.prototype.slice.call(g.querySelectorAll('.product-gallery__media'));
    }

    // DOM-Index des aktuell sichtbaren Varianten-Slides (= erstes sichtbares
    // Varianten-Hauptbild). Liegt durch die serverseitige Umsortierung vorne.
    function selectedSlideIndex() {
      var slides = getSlides();
      for (var i = 0; i < slides.length; i++) {
        if (ids.indexOf(slides[i].getAttribute('data-media-id')) !== -1 && !slides[i].hasAttribute('hidden')) {
          return i;
        }
      }
      return -1;
    }

    // Das Theme scrollt bei Variantenwechsel per Shopify-Medienposition
    // (carousel.select(featured_media.position - 1)). Nach der serverseitigen
    // Umsortierung (Varianten-Hauptbilder zuerst) stimmt diese Position nicht mehr
    // mit dem DOM-Index ueberein. Wir korrigieren die Auswahl ueber die NATIVE
    // Carousel-API auf den korrekten DOM-Index -> Carousel + Thumbnails (via
    // carousel:change -> page-dots align-selected) landen am Anfang.
    function syncSelection() {
      if (!carousel || typeof carousel.select !== 'function') return;
      var idx = selectedSlideIndex();
      if (idx === -1) return;
      carousel.select(idx, { animate: false });
    }

    function run() {
      requestAnimationFrame(syncSelection);
      setTimeout(syncSelection, 150);
      setTimeout(syncSelection, 400);
    }

    run();

    if (carousel) {
      carousel.addEventListener('carousel:filter', run);
    }

    if (form) {
      form.addEventListener('variant:change', run);
    }

    new MutationObserver(run).observe(g, { attributes: true, attributeFilter: ['filtered-indexes'] });
  }

  function init() {
    document.querySelectorAll('product-gallery[data-ji-qty]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
